import { render } from "./FirstTab.vue?vue&type=template&id=37a838f7&scoped=true"
import script from "./FirstTab.vue?vue&type=script&lang=js"
export * from "./FirstTab.vue?vue&type=script&lang=js"

import "./FirstTab.vue?vue&type=style&index=0&id=37a838f7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a838f7"]])

export default __exports__